import DailyPrayerCard from './CardPrayerDaily';

export default DailyPrayerCard;
